import React, { useContext } from "react";
import "./CommunityBanner.scss";
import commImg from "./../../../assets/community.png";
import UserContext from "../../../context/UserContext";

const CommunityBanner = () => {
  const { userDetail } = useContext(UserContext);
  return (
    <div className="membership-container">
      <h1 className="welcome">Hi {userDetail?.member_name} !</h1>
      <span className="commImgContainer">
        <img src={commImg} alt="" />
      </span>
      <p className="commBannerHead">Want a match? Need a team? Just Bored?</p>
      <p className="members-get">Our WhatsApp community got you </p>

      <button
        className="join-button"
        onClick={() => {
          window.open(
            "https://chat.whatsapp.com/BnefKDg9B2ZJO4M0Lybcjp",
            "_blank"
          );
        }}
      >
        Join Community
      </button>
    </div>
  );
};

export default CommunityBanner;
